// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkflowStageTarget = {
    Draft: 'DRAFT',
    Review: 'REVIEW',
    Approved: 'APPROVED',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Invalid: 'INVALID'
} as const;
export type WorkflowStageTarget = typeof WorkflowStageTarget[keyof typeof WorkflowStageTarget];


export function instanceOfWorkflowStageTarget(value: any): boolean {
    for (const key in WorkflowStageTarget) {
        if (Object.prototype.hasOwnProperty.call(WorkflowStageTarget, key)) {
            if (WorkflowStageTarget[key as keyof typeof WorkflowStageTarget] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkflowStageTargetFromJSON(json: any): WorkflowStageTarget {
    return WorkflowStageTargetFromJSONTyped(json, false);
}

export function WorkflowStageTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowStageTarget {
    return json as WorkflowStageTarget;
}

export function WorkflowStageTargetToJSON(value?: WorkflowStageTarget | null): any {
    return value as any;
}

export function WorkflowStageTargetToJSONTyped(value: any, ignoreDiscriminator: boolean): WorkflowStageTarget {
    return value as WorkflowStageTarget;
}
